import React, { Component } from 'react';
import { Button, Upload, message, Modal } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import { xToken } from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import Filter from './Filter';
import { Evaluation } from './Widget';
import FailureRecord from './FailureRecord';
import TableC from '../../basicElement/TableC';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import format from '../../shared/format';
import SideNav from '../SideNav';
import moment from 'moment';
import FieldSettingsModel from './FieldSettingsModel';
import { calcDisplayColumns } from './common';
import Exportcuredata from './Exportcuredata'

class OtherChargesReport extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            startOper: 'EQ',
            endOper: 'EQ',
            // dateStart:moment().format('YYYY-MM'),
            // dateEnd:moment().format('YYYY-MM'),
        };
        this.state = {
            data: [],
            loading: false,
            uploading: false,
            sortParams: {},
            curParams: {...searchParams},
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            canEdit: false,
            onlineMonth: '',
            columnsTitle: [],
            businessList: [],
            contractTypeList: [],
            fileList: [],
            signingUnitOptions: [],
            belongingToUnitOptions: [],
            endMonth: '',
            startMonth: '',
            operable: false,
            showFailureRecord: false,
        };
    }

    componentDidMount() {
        this.querySigningUnit();
        this.queryBelongingToUnit();
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
        this.queryHead();
    }

    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfSigningList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, res => {
            const { datas = [] } = res;
            const signingUnitOptions = (datas || []).map(i => ({ value: i.unitOfSigningId, label: i.unitOfSigningName }));
            this.setState({ signingUnitOptions });
        });
    }

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfBelongingList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, res => {
            const { datas = [] } = res;
            const belongingToUnitOptions = (datas || []).map(i => ({ value: i.unitOfBelongingId, label: i.unitOfBelongingName }));
            this.setState({ belongingToUnitOptions });
        });
    }

    queryFixedLineTime = () => {
        Fetch.post(API_URL.finance.queryFixedLineTime).then(res => {
            const { data } = res;
            if (!data || data.length === 0) {
                this.setState({ operable: false });
                return;
            }
            const { searchParams } = this.state;
            const startMonth = moment(format('month', data[0].year, data[0].month)).format('YYYY-MM');
            const endMonth = moment(format('month', data[data.length - 1].year, data[data.length - 1].month)).format('YYYY-MM');
            searchParams.date = endMonth;
            this.setState({
                endMonth,
                startMonth,
                searchParams,
                operable: true,
                curParams: searchParams,
            }, () => {
                this.queryEffectiveDate();
            });
        });
    }

    queryEffectiveDate = () => {
        Fetch.post(API_URL.home.queryEffectiveDate).then(res => {
            const { date,month,year } = res;
            const { searchParams } = this.state;
            const endMonth = moment(date).format('YYYY-MM');
            searchParams.dateStart = endMonth;
            searchParams.dateEnd = endMonth;
            searchParams.month = month;
            searchParams.year = year;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList).then(cb);
        }, res => {
            const { contractTypeList } = res;
            this.setState({ contractTypeList });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb);
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.finance.queryPrepaidRecordList, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...params,
        }).then(res => {
            const { data: { month, year, canEdit }, datas, totalCount } = res;
            const { yearAmounts } = datas && datas.length ? datas[0] : {};
            const onlineMonth = `${year}-${month < 10 ? `0${month}` : month}`;
            pagination.total = totalCount;
            const columnsTitle = [];
            (yearAmounts || []).forEach(i => {
                const { yearNum } = i;
                columnsTitle.push({
                    title: `${yearNum}代垫费用在手订单额合计`,
                    dataIndex: `${yearNum}`,
                    key: `${yearNum}`,
                    width: 80,
                });
            });
            datas.forEach(item => {
                const { yearAmounts } = item;
                (yearAmounts || []).forEach(i => {
                    const { yearNum, prepaidAmount } = i;
                    item[`${yearNum}`] = format('money', prepaidAmount);
                });
            });
            this.setState({
                loading: false,
                data: datas,
                pagination,
                columnsTitle,
                onlineMonth,
                canEdit,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams}
        }, () => {
            this.resetHead();
        });
    }

    resetHead=()=>{
        this.setState({ loading: true });
        const{ searchParams }=this.state;
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'PREPAID_FEE',
            ...searchParams,
        }).then(res => {
            const { PREPAID_FEE } = res;
            this.setState({ loading: false });
            this.setState({ head: PREPAID_FEE }, () => {
                this.loadData();
            });
        }).catch(error => {
            console.error(error);
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.finance.exportPrepaidRecordList, {
            ...sortParams,
            ...params,
            offset: 1,
        }).then(res => {
            message.success(res.success);
        });
    }

    download = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.finance.getFtpPrepaidFeeImport;
        ExportUtil.export({ ...params }, null, url);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split(',');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ',' : ''}<br /></span>;
        });
        return result;
    }

    getRender = (key) => (text, record) => record[key] ? record[key] : text

    queryHead = () => {
        this.setState({ loading: true });
        const{ searchParams }=this.state;
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'PREPAID_FEE',
            ...searchParams,
        }).then(res => {
            const { PREPAID_FEE } = res;
            this.setState({ loading: false });
            this.setState({ head: PREPAID_FEE }, () => {
                this.queryFixedLineTime();
            });
        }).catch(error => {
            console.error(error);
        });
    }

    getColumns = () => {
        const { columnsTitle, canEdit,head,data } = this.state;
        const columns = [{
            title: '合同收入确认时间',
            dataIndex: 'recordYearMonthShow',
            key: 'recordYearMonthShow',
            fixed: 'left',
            width: 120,
            // render: (text, record) => {
            //     const { recordYear, recordMonth } = record;
            //     return `${recordYear}${recordMonth < 10 ? `0${recordMonth}` : recordMonth}`;
            // }
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
            render: this.getRender('signingUnitMerge'),
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
            render: this.getRender('belongingToUnitMerge'),
        }, {
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, 
        {
            title: '名称(Project ID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 120,
            render: this.getRender('projectIdNameMerge'),
        }, {
            title: '合同是否签署完成',
            dataIndex: 'contractIsSignedMerge',
            key: 'contractIsSignedMerge',
            width: 80,
        }, {
            title: '合同新增时间',
            dataIndex: 'contractCreateTime',
            key: 'contractCreateTime',
            width: 90,
            render: this.getRender('createTimeMerge'),
        }, {
            title: '过账编辑',
            dataIndex: 'postingEdit',
            key: 'postingEdit',
            width: 80,
        }, {
            title: '类别码13',
            dataIndex: 'categoryCode13',
            key: 'categoryCode13',
            width: 90,
            render: (text, record) => {
                return text ? <span style={{ color: record.categoryCodeStatus == 1 && 'red' }}>{text}</span> : '';
            }
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessShow',
            key: 'lineOfBusinessShow',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 90,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
            render: this.getRender('contractNatureMerge'),
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldCustomerCompanyCode'])
            })(this.getRender('customerJdeCodeMerge')),
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
            render: cellRenderEnhancer({
                 renderContent: beforeChangeEnhancer((record) => record['oldCustomerCompanyName'])
            })(this.getRender('customerCompanyNameMerge')),
        }, {
            title: 'PM工号',
            dataIndex: 'pmEmployeeCode',
            key: 'pmEmployeeCode',
            width: 80,
        }, {
            title: 'PM姓名',
            dataIndex: 'pmUserCompellation',
            key: 'pmUserCompellation',
            width: 80,
        }, {
            title: 'PM主管工号',
            dataIndex: 'pmLeaderEmployeeCode',
            key: 'pmLeaderEmployeeCode',
            width: 85,
        }, {
            title: 'PM主管姓名',
            dataIndex: 'pmLeaderUserCompellation',
            key: 'pmLeaderUserCompellation',
            width: 85,
        }, {
            title: 'BD工号',
            dataIndex: 'bdCodes',
            key: 'bdCodes',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BD姓名',
            dataIndex: 'bdNames',
            key: 'bdNames',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BA工号',
            dataIndex: 'baCodes',
            key: 'baCodes',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BA姓名',
            dataIndex: 'baNames',
            key: 'baNames',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeValue',
            key: 'investigationMedicineTypeValue',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'invByStageShow',
            key: 'invByStageShow',
            width: 120,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 80,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '项目领域',
            dataIndex: 'invAreaShow',
            key: 'invAreaShow',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeShow',
            key: 'contractTypeShow',
            width: 80,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
           })(),
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartTime',
            key: 'contractStartTime',
            width: 90,
            render: (text, record) => {
                const { contractStartTimeMerge } = record;
                return contractStartTimeMerge ? contractStartTimeMerge : text ? text.slice(0, 10) : '';
            }
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndTime',
            key: 'contractEndTime',
            width: 90,
            render: (text, record) => {
                const { contractEndTimeMerge } = record;
                return contractEndTimeMerge ? contractEndTimeMerge : text ? text.slice(0, 10) : '';
            }
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'contractIsSpecifiesAmountMerge',
            key: 'contractIsSpecifiesAmountMerge',
            width: 90,
        }, {
            title: '币种',
            dataIndex: 'currencyName',
            key: 'currencyName',
            width: 100,
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: 'FTE 单价(不含税)',
            dataIndex: 'fteUnitPriceNoTax',
            key: 'fteUnitPriceNoTax',
            width: 80,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/原币',
            dataIndex: 'initialActualExpenseFee',
            key: 'initialActualExpenseFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/原币',
            dataIndex: 'initialActualFee',
            key: 'initialActualFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'cnyContractAmount',
            key: 'cnyContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/人民币',
            dataIndex: 'cnyActualExpenseFee',
            key: 'cnyActualExpenseFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/人民币',
            dataIndex: 'cnyActualFee',
            key: 'cnyActualFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用不含税/人民币',
            dataIndex: 'cnyPrepaidFeeNoTax',
            key: 'cnyPrepaidFeeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '截止当月末POC%',
            dataIndex: 'currentMonthEndPoc',
            key: 'currentMonthEndPoc',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '截止到上月末POC%',
            dataIndex: 'lastMonthEndPoc',
            key: 'lastMonthEndPoc',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '当月完成POC%',
            dataIndex: 'currentMonthFinishPoc',
            key: 'currentMonthFinishPoc',
            width: 100,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '代垫费用累计收入不含税/原币',
            dataIndex: 'prepaidInitialTotalIncomeNoTax',
            key: 'prepaidInitialTotalIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用累计收入不含税/人民币',
            dataIndex: 'prepaidCnyTotalIncomeNoTax',
            key: 'prepaidCnyTotalIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用累计上月收入不含税/原币',
            dataIndex: 'prepaidInitialTotalLastMonthIncomeNoTax',
            key: 'prepaidInitialTotalLastMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用累计上月收入不含税/人民币',
            dataIndex: 'prepaidCnyTotalLastMonthIncomeNoTax',
            key: 'prepaidCnyTotalLastMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用当月收入不含税/原币',
            dataIndex: 'prepaidInitialCurrentMonthIncomeNoTax',
            key: 'prepaidInitialCurrentMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '代垫费用当月收入不含税/人民币',
            dataIndex: 'prepaidCnyCurrentMonthIncomeNoTax',
            key: 'prepaidCnyCurrentMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, 
        // {
        //     title: '代垫费用当年收入不含税/原币',
        //     dataIndex: 'prepaidInitialCurrentYearIncomeNoTax',
        //     key: 'prepaidInitialCurrentYearIncomeNoTax',
        //     width: 100,
        //     render: text => format('money', text),
        // }, {
        //     title: '代垫费用当年收入不含税/人民币',
        //     dataIndex: 'prepaidCnyCurrentYearIncomeNoTax',
        //     key: 'prepaidCnyCurrentYearIncomeNoTax',
        //     width: 100,
        //     render: text => format('money', text),
        // },
         {
            title: '代垫费用在手订单额不含税/人民币',
            dataIndex: 'prepaidOrderInHandNoTax',
            key: 'prepaidOrderInHandNoTax',
            width: 100,
            render: text => format('money', text),
        }];
        columns.push(...columnsTitle);

        const { curRole } = sessionStorage;
 
        const result = data&&data.length>0?calcDisplayColumns(columns, head):columns;

        if ((curRole === 'FIN')&&canEdit) {
            result.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                fixed: 'right',
                width: 80,
                render: (text, record) => {
                    return (
                        canEdit ?
                            <a onClick={() => this.evaluation(record)}>赋值</a>
                        :
                            <a disabled>赋值</a>
                    );
                },
            });
        }

        return result;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    evaluation = (record) => {
        this.evaluationRef.show(record);
    }

    beforeUpload = file => {
        this.setState({ uploading: true });
    }

    handleChange = ({ file, fileList }) => {
        const { fileList: fList } = this.state;
        const { status, uid, response } = file;
        if (status === 'done' && (fList || []).find(i => i.uid == uid)) {
            this.setState({ uploading: false });
            const { success, error, failDataNum } = response || {};
            if (success) {
                Modal.confirm({
                    iconType: 'exclamation-circle',
                    title: <div style={{ marginLeft: 42 }}>本次导入的代垫费用收入报告</div>,
                    content: (success || '').split(';').map(i => <span>{i}<br /></span>),
                    onOk: () => {
                        if (failDataNum) {
                            const { curParams: { dateEnd } } = this.state;
                            const url = API_URL.finance.downloadErrorPrepaidFee;
                            ExportUtil.export({ date: dateEnd }, null, url);
                        }
                    },
                    okText: failDataNum ? '下载错误报告' : '确定',
                    cancelText: '关闭',
                });
            } else if (error) {
                message.error(error);
            }
        }

        this.setState({ fileList });
    }

    showFailureRecord = (showFailureRecord) => {
        this.setState({ showFailureRecord });
    }

    showFieldSettings=()=>{
        this.fieldSettingsRef.show();
    }
    
    showExportcuredata(){
        this.Exportcuredata.showModal()
    }

    render() {
        const { curRole } = sessionStorage;
        const isFIN = curRole === 'FIN';
        //const isFIN = true;
        const {
            data,
            loading,
            uploading,
            pagination,
            searchParams,
            curParams,
            sortParams,
            businessList,
            contractTypeList,
            columnsTitle,
            onlineMonth,
            fileList,
            signingUnitOptions,
            belongingToUnitOptions,
            endMonth,
            startMonth,
            canEdit,
            operable,
            showFailureRecord,
        } = this.state;
        const { date, dateEnd } = curParams;
        const isCurrentMonth = date === onlineMonth;
        return (
            <div className="content">
                <SideNav selectKey='otherChargesReport' />
                <div className="main" style={{ display: showFailureRecord ? 'none' : 'block' }}>
                    <Filter
                        operable={operable}
                        endMonth={endMonth}
                        startMonth={startMonth}
                        expandHeight={160}
                        search={this.search}
                        params={searchParams}
                        businessList={businessList}
                        contractTypeList={contractTypeList}
                        onChange={this.handleFilterChange}
                        signingUnitOptions={signingUnitOptions}
                        belongingToUnitOptions={belongingToUnitOptions}
                        buttons={[
                            <Button key="export" type="primary" disabled={!operable} onClick={this.export}>导出</Button>,
                            isFIN && <Button key="download" type="primary" onClick={this.download}>下载模板</Button>,
                            isFIN && <Upload
                                key="import"
                                data={{
                                    date: dateEnd,
                                    curUserId: sessionStorage.userId,
                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                }}
                                showUploadList={false}
                                action={API_URL.finance.importPrepaidFee}
                                beforeUpload={this.beforeUpload}
                                onChange={this.handleChange}
                                fileList={fileList}
                                headers={xToken}
                            >
                                <Button type="primary" disabled={!operable || !canEdit || uploading}>导入数据</Button>
                            </Upload>,
                            <Button key="failure" type="primary" className="yellow" disabled={!operable} onClick={() => this.showFailureRecord(true)}>失败记录</Button>,
                            <Button key="FieldSettings" type="primary"  onClick={() => this.showFieldSettings()}>字段设置</Button>,
                            <Button key="Exportcuredata" type="primary"  onClick={() => this.showExportcuredata()}>导出固化数据</Button>
                        ]}
                    />
                    <Exportcuredata 
                        searchParams={searchParams}
                        ref = {el => this.Exportcuredata = el}/>
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        rowKey="investigationJdeContractRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <Evaluation ref={el => this.evaluationRef = el} loadData={this.loadData} isCurrentMonth={isCurrentMonth} onlineMonth={onlineMonth} columnsTitle={columnsTitle} />
                </div>
                <FieldSettingsModel ref={el => this.fieldSettingsRef = el}  queryHead={this.queryHead} searchParams={searchParams}/>
                {
                    showFailureRecord &&
                    <FailureRecord
                        date={dateEnd}
                        showFailureRecord={this.showFailureRecord} 
                        serParams={searchParams}
                    />
                }
            </div>
        );
    }
}

export default OtherChargesReport;


// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/index.js